import { StateData } from '../enums/State';

export const getStateLabelByValue = (value: number) => {
  const stateValues = Object.values(StateData);
  const stateInfo = stateValues.find(state => state.value === value);
  return stateInfo ? stateInfo.label : null;
};
